import { useQuery } from '@tanstack/react-query';
import { requestNextPaymentDue } from './nextPaymentDueApi';

export const nextPaymentDueKey = ['payments', 'nextPaymentDue'] as const;

/** The member's next scheduled payment amount and due date for the Payment Summary card's Next Amount Due slot. */
export function useNextPaymentDue() {
  return useQuery({
    queryKey: nextPaymentDueKey,
    queryFn: requestNextPaymentDue,
  });
}
